import EditableTable from 'components/common/EditableTable'
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import { usePermissions } from 'layouts/Admin';
import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { fetchVerifiedInvoices } from 'slices/invoiceSlice';
import { verifyInvoice } from 'slices/invoiceSlice';
import { fetchAppointClients } from 'slices/invoiceSlice';
import { updateInvoice } from 'slices/invoiceSlice';
import { invoicesSelector } from 'slices/invoiceSlice';
import { fetchUnVerifiedInvoices } from 'slices/invoiceSlice';

const InvoiceAppointmentDetail = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const refAddutton = React.useRef(null);
    const { checkPermission } = usePermissions();
    const [currentPage, setCurrentPage] = React.useState(1);
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });
    const { appointClients, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(invoicesSelector);
    const [searchTerm, setSearchTerm] = React.useState("");
    React.useEffect(() => {
        dispatch(fetchAppointClients(1, { client_ids: id }))
    }, [])

    const data = appointClients?.find(t => t.id === Number(id));

    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchAppointClients(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
        }
        return (
            <tr>
                <th>
                    <div className="row_check">
                        <span>Prog. #</span>
                    </div>
                </th>
                <th >
                    <TableHeaderItem
                        title="Appointment Number"
                        sortBy="appt_no"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Date & Time"
                        sortBy="datetime"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Start Time"
                        sortBy="start_time"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="End Time"
                        sortBy="end_time"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Total Hours"
                        sortBy="total_hours"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Rate"
                        sortBy="rate"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Total"
                        sortBy="total"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Facility"
                        sortBy="facility"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Requestor"
                        sortBy="requestor"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Language"
                        sortBy="language"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Interpreter Name"
                        sortBy="interpreter_name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Notes"
                        sortBy="notes"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
            </tr>
        )
    }, [searchTerm, sortConfig, currentPage]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            data?.appointments?.map((item, index) => (
                <AppointClientItems data={item} index={index} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
            ))
        )
    }, [appointClients]);

    //#endregion


    return (
        <ListLayout
            time={false}
            haveBackBtn={true}
            heading={data?.user?.name}
            addButtonDisabled={true}
            renderTableHeader={renderTableHeader}
            renderTableContent={renderTableContent}
            hideRemoveButton={true}
            invoiceButton={true}
            totalPages={totalPages}
            fetchList={fetchAppointClients}
            refAddutton={refAddutton}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            loader={loader}
            noOfItems={total}
            searchPlaceholder="Search..."
        >
        </ListLayout>
    )
}

const AppointClientItems = ({
    data, index, current_page, pageLength, checkPermission
}) => {
    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{serial}</span>
                </div>
            </td>
            <td>
                {checkPermission('Detail Appointments') ?
                    <Link className='link_preview' to={`/appointments/view/${data?.id}`}>
                        {data?.appid || "N/A"}
                    </Link>
                    :
                    data?.appid || "N/A"
                }
            </td>
            <td>
                {data.datetime || "N/A"}
            </td>
            <td>
                {data?.appointment_assign?.checkin_time || "N/A"}
            </td>
            <td>
                {data?.appointment_assign?.checkout_time || "N/A"}
            </td>
            <td>
                {data?.invoice?.total_hours || "N/A"}
            </td>
            <td>
                ${(data?.invoice?.rate && data?.invoice?.rate_unit)
                    ? (data.invoice.rate +'/'+ data.invoice.rate_unit)
                    : 0}
            </td>
            <td>
                ${data.invoice?.total_amount ? parseFloat(data.invoice?.total_amount)?.toFixed(2) : 0.00}
            </td>
            <td>
                {data?.appointment_details?.facility?.facility_name || data?.appointment_details?.address || 'N/A'}
            </td>
            <td>
                {data?.appointment_details?.requester_name}
            </td>
            <td>
                {data.language?.name}
            </td>
            <td>
                {data?.interpreter?.first_name ? (data?.interpreter?.first_name + " " + data?.interpreter?.last_name) : 'N/A'}
            </td>
            <td>
                {data?.invoice?.notes || "N/A"}
            </td>
            <td className='text-capitalize'>
                {data?.status || "N/A"}
            </td>
        </tr>
    )
}


export default InvoiceAppointmentDetail